<template>
  <section v-if="show" class="px-4" style="position: fixed; bottom: 0; z-index: 1;">
    <v-alert dense icon="mdi-cookie">
      <span class="caption d-flex">
        We use cookies to improve your experience.
      </span>
      
      <template v-slot:prepend>
        <v-icon left>mdi-cookie</v-icon>
      </template>
      
      <template v-slot:append>
        <v-btn class="ml-3" small text :ripple="false">Got it</v-btn>
      </template>
    </v-alert>
  </section>
</template>


<script>
export default {
  data() {
    return {
      show: true,
    };
  },
};
</script>

<style>
</style>